module["exports"] = [
  "United States of America"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/en/address/default_country.js
// module id = 2030
// module chunks = 2